import React from 'react';
import styles from './LabelPergunta.module.scss';

function LabelPergunta({ descricao, isBlue = false, required = false }) {
    return (
        <div className={styles.labelPergunta}>
            <span className={`${isBlue ? styles.azul : styles.cinza}`}>{`${descricao}:`}</span>
            <span className={styles.required}>{`${required ? '*' : ''}`}</span>
        </div>
    );
}

export default LabelPergunta;
